import { connect } from 'react-redux'
import component from './component'
import {
  MODAL,
  HOLIDAY
} from '../../../reduxs'

function mapStateToProps (state, ownProps) {
  return {
    accountReducer: state.accountReducer,
    settingReducer: state.settingReducer,
    language: state.accountReducer.language,
    username: state.accountReducer.user.username,
    userCompany: state.accountReducer.user.companyId,
    buildingId: state.accountReducer.user.buildingId,
    modalStatus: state.modalReducer.status,
    modalReducer: state.modalReducer,
    holidayList: state.holidayReducer.listHoliday,
    minuteStep: state.accountReducer.user.minuteStep,
    startOperatingTime: state.accountReducer.user.startOperatingTime,
    endOperatingTime: state.accountReducer.user.endOperatingTime
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModalStatus: (div) => dispatch(MODAL.action.openModalStatus(div)),
    closeModalStatus: () => dispatch(MODAL.action.closeModalStatus()),
    openModalConfirm: (div) => dispatch(MODAL.action.openModalConfirm(div)),
    closeModalConfirm: () => dispatch(MODAL.action.closeModalConfirm()),
    getListHoliday: (param) => dispatch(HOLIDAY.action.getListHoliday(param)),
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps, mapDispatchToProps),
  (dispatch) => mapDispatchToProps(dispatch),
)(component)
